import React, { Component } from "react";
import { getParentPostInfo } from "./postInfoUtils";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import "./ParentPost.scss";

import { ReactComponent as LikeIcon } from "../../../../assets/svg/like.svg";
import { ReactComponent as CommentIcon } from "../../../../assets/svg/comment.svg";
import { ReactComponent as ShareIcon } from "../../../../assets/svg/share.svg";
import { ReactComponent as YTLikeIcon } from "../../../../assets/svg/youtube-post-like.svg";
import { ReactComponent as YTDisLikeIcon } from "../../../../assets/svg/youtube-post-unlike.svg";

import blankUser from "./icons/user_blank.png";
import engagementIcon from "./icons/engagement_icon.png";
import viewsIcon from "./icons/views_icon.png";

let socialIcons = {
    engagementIcon,
    viewsIcon,
};

class ParentPost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
        };
    }

    handleImageError() {
        this.authorImage.src = blankUser;
    }

    render() {
        let info = getParentPostInfo(this.props.data);
        return (
            info && (
                <div className={`parent-post-container ${this.props.listView ? "parent-post-container-listView" : ""}`}>
                    <div className="parent-post">
                        <div className="parent-post-header skiptranslate">
                            {info.postAuthorImg && (
                                <div className="post-author-image">
                                    <img
                                        src={info.postAuthorImg}
                                        alt=""
                                        onError={() => this.handleImageError()}
                                        ref={(el) => {
                                            this.authorImage = el;
                                        }}
                                    />
                                </div>
                            )}
                            <div className="post-details skiptranslate">
                                <div className="post-details-top" data-html2canvas-ignore="true">
                                    <Popup
                                        trigger={<span className="post-author-name">{info.postAuthor}</span>}
                                        content={info.postAuthor}
                                        inverted
                                        size="mini"
                                        position="top center"
                                        className="skiptranslate"
                                    />
                                    <div className="post-details-separator"></div>
                                    <Popup
                                        trigger={<span className="post-publish-time">{info.postTime[0]}</span>}
                                        content={info.postTime[1]}
                                        inverted
                                        size="mini"
                                        position="top center"
                                        className="skiptranslate"
                                    />
                                </div>
                                <div className="post-details-bottom">
                                    {info.followersCount && <span className="post-author-followers-count">{info.followersCount + " followers"}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="parent-post-content" dangerouslySetInnerHTML={{ __html: info.post }}></div>
                        <div className="parent-post-footer skiptranslate">
                            {info.likesCount && (
                                <div className="likes parent-post-footer-item">
                                    {this.props.platformName === "Youtube" ? <YTLikeIcon /> : <LikeIcon />}
                                    <span className="count">{info.likesCount}</span>
                                </div>
                            )}
                            {info.dislikesCount && (
                                <div className="dislikes parent-post-footer-item">
                                    <YTDisLikeIcon />
                                    <span className="count">{info.dislikesCount}</span>
                                </div>
                            )}
                            {info.commentsCount && (
                                <div className="comments parent-post-footer-item">
                                    {this.props.platformName !== "Youtube" && <CommentIcon />}
                                    <span className="count">{info.commentsCount + this.props.platformName === "Youtube" ? " Comments" : ""}</span>
                                </div>
                            )}
                            {info.viewsCount && (
                                <div className="views parent-post-footer-item">
                                    <span className="count">{`${info.viewsCount} Views`}</span>
                                </div>
                            )}
                            {info.sharesCount && (
                                <div className="shares parent-post-footer-item">
                                    <ShareIcon />
                                    <span className="count">{info.sharesCount}</span>
                                </div>
                            )}
                            {info.totalEngagedUsers && info.totalReach && (
                                <div className="engagementRate parent-post-footer-item">
                                    <img src={socialIcons[info.socialIcons.engagementRate.img]} alt="engagement_rate" />
                                    <span className="count">{info.engagementRate}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        );
    }
}

export default ParentPost;
